<template>
  <v-card class="mx-auto">
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header class="primary text-h5 text-left white--text"
          ><span>
            Documents
            <BaseTooltipButton
              v-if="userHasEditPerms"
              x-small
              @click.stop="$refs.documentForm.addDocument()"
              icon="mdi-plus"
              iconColor="secondary"
              buttonClass="white"
              >Add Document
            </BaseTooltipButton>
          </span>
          <template v-slot:actions>
            <v-icon class="white--text">$vuetify.icons.expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-card-text>
            <!-- <v-row>
            <v-col class="ml-auto" cols="12" sm="auto">
              <v-text-field
                v-model="searchText"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="auto" class="mt-4 mr-4"> </v-col>
          </v-row> -->
            <div class="viewer" id="note-view">
              <template v-for="d in sortedDocuments">
                <div :key="d.Id">
                  <div
                    class="document"
                    :class="
                      d.CreatedByID == currentUser.ID
                        ? ' user-document'
                        : ' non-user-document'
                    "
                    ><a @click="downloadDocument(d)">
                      {{ d.FileName }}
                    </a>
                    <div
                      class="user-data"
                      :class="
                        d.CreatedByID == currentUser.ID ? 'user-document' : ''
                      "
                      ><span
                        v-if="d.CreatedBy.FirstName && d.CreatedBy.LastName"
                        >{{ d.CreatedBy.FirstName }}
                        {{ d.CreatedBy.LastName }}</span
                      ><span v-else>
                        {{ d.CreatedBy.Email }}
                      </span>
                      -
                      {{ d.CreatedDate | formatDateTime }}
                      <span v-if="d.CreatedByID == currentUser.ID">
                        <BaseTooltipButton
                          x-small
                          @click="$refs.documentDelete.deleteConfirm(d)"
                          iconColor="primary"
                          icon="mdi-delete"
                          >Delete Document
                        </BaseTooltipButton>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- <v-data-table
          :headers="filteredHeaders"
          :items="documents"
          :search="searchText"
          class="pt-4"
          dense
        >
          <template v-slot:item.edit="{ item }">
            <BaseTooltipButton
              small
              @click="$refs.documentForm.editDocument(item)"
              iconColor="primary"
              icon="mdi-pencil"
              >Edit Document
            </BaseTooltipButton>
          </template>
          <template v-slot:item.delete="{ item }">
          </template>
        </v-data-table> -->
      <BaseDeleteConfirm
        ref="documentDelete"
        :delete="deleteDocument"
        @refresh="$emit('refresh')"
      >
        Are you sure you want to delete this document?
      </BaseDeleteConfirm>
      <DocumentDialogForm ref="documentForm" @refresh="$emit('refresh')">
      </DocumentDialogForm>
    </v-expansion-panels>
  </v-card>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import DocumentDialogForm from '@components/form/add-edit/DocumentDialog'
import { authMethods, authComputed } from '@state/helpers'
import download from 'downloadjs'
export default {
  components: {
    DocumentDialogForm,
  },

  data: () => ({
    searchText: '',
    panel: [0],
  }),
  created() {},
  props: {
    documents: {
      type: Array,
      required: true,
    },
    loading: Boolean,
  },
  computed: {
    ...authComputed,
    ...get('trackedBill', ['selectedTrackedBill']),
    sortedDocuments() {
      return this.documents
        .filter((c) => true)
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
    },
    userHasEditPerms() {
      return (
        this.selectedTrackedBill.currentUserPermissionID == 1 ||
        this.selectedTrackedBill.currentUserPermissionID == 2 ||
        this.selectedTrackedBill.currentUserPermissionID == 5
      )
    },
  },
  methods: {
    ...call('document', ['deleteDocument']),
    handleError: call('errors/handleError'),
    downloadDocument(doc) {
      let url
      url = `Document/Download/${doc.Id}`
      let headers = { responseType: 'blob' }
      this.$axios.get(url, headers).then(
        (res) => {
          const content = res.headers['content-type']
          const dispo = res.headers['content-disposition']
          var filename = ''
          if (dispo && dispo.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            var matches = filenameRegex.exec(dispo)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }
          download(res.data, filename, content)
        },
        (error) => {
          this.handleError(error)
          console.log(error)
        }
      )
    },
  },
}
</script>
<style>
.document {
  white-space: pre-wrap;
  margin: 5px;
  min-height: 50px;
  min-width: 200px;
  max-width: 85%;
  border-radius: 5px;
  padding: 4px;
  color: black;
  background-color: #dcebf3;
}
.user-document {
  /* text-align: right; */
  margin-right: 0px;
  margin-left: auto;
}
</style>
